<template>
  <div class="vx-row">
    <div class="vx-col md:w-1/1 w-full">
      <vx-card>
        <span>
          <h4 class="mb-4" v-if="this.$route.params.id">Edit Role Menu</h4>
          <h4 class="mb-4" v-else>Add Role Menu</h4>
        </span>
        <div class="vx-row mb-6 ml-4 mr-4">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Role</span>
          </div>
          <div class="vx-col sm:w-4/5 w-full">
            <vs-input class="w-full" v-model="role" readonly />
          </div>
        </div>
        <div class="vx-row mb-6 ml-4 mr-4">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Menu</span>
          </div>
          <div class="vx-col sm:w-4/5 w-full">
            <ul v-for="menu in data" :key="menu.module_id">
              <li class="mb-1">
                <vs-checkbox
                  v-if="menu.parent_id == 0"
                  :checked="menu.selected"
                  @click="addChecked(menu.module_id, null)"
                  style="margin-bottom: 8px;"
                >{{ menu.display_name }}</vs-checkbox>
                <vs-checkbox
                  v-else
                  style="margin-left: 5%; margin-bottom: 8px;"
                  :checked="menu.selected"
                  @click="addChecked(menu.module_id, menu.parent_id)"
                >{{ menu.display_name }}</vs-checkbox>
                <div
                  v-if="menu.parent_id != 0 && menu.permissions && menu.permissions.length"
                  style="margin-left: 10%;"
                >
                  <vs-checkbox
                    v-for="perm in menu.permissions"
                    :key="perm.id"
                    :checked="perm.selected"
                    @click.stop="togglePermission(menu.module_id, perm.id)"
                    style="margin-bottom: 8px;"
                  >{{ perm.guard_name.charAt(0).toUpperCase() + perm.guard_name.slice(1) }}</vs-checkbox>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="vx-row mb-6 ml-4 mr-4">
          <div class="vx-col sm:w-4/5 w-full ml-auto">
            <vs-button v-if="this.$route.params.id" @click="handleSubmit" class="mr-3 mb-2">Update</vs-button>
            <vs-button v-else @click="handleSubmit" class="mr-3 mb-2">Create</vs-button>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
export default {
  components: {
    vSelect
  },
  beforeMount() {
    this.getMenu();
  },
  data() {
    return {
      data: [],
      selected: [],
      selectedPermissions: [],
      role: "",
    };
  },
  methods: {
    addChecked(val, valParent) {
      if (this.selected.includes(val)) {
        this.selected.splice(this.selected.indexOf(val), 1);
        this.data.forEach(element => {
          if (element.parent_id == val) {
            element.selected = false;
            if (element.parent_id != 0) {
              element.selected = false;
              this.selected.splice(this.selected.indexOf(element.module_id), 1);
            }
          }
          if (element.module_id == val) {
            element.selected = false;
          }
        });
      } else {
        this.selected.push(val);
        this.data.forEach(element => {
          if (element.parent_id == val) {
            element.selected = true;
            if (!this.selected.includes(element.module_id)) {
              this.selected.push(element.module_id);
            }
          }
          if (element.module_id == val) {
            element.selected = true;
          }
          if (element.parent_id == 0 && element.module_id == valParent) {
            element.selected = true;
            if (!this.selected.includes(element.module_id)) {
              this.selected.push(element.module_id);
            }
          }
        });
      }
      this.data.forEach(element => {
        let status = [];
        if (element.module_id == valParent) {
          this.data.forEach(element1 => {
            if (element1.parent_id == valParent) {
              status.push(element1.selected);
            }
          });
          if (status.includes(true)) {
            element.selected = true;
          } else {
            element.selected = false;
            this.selected.splice(this.selected.indexOf(element.module_id), 1);
          }
        }
      });
    },
    togglePermission(menuId, permId) {
      const menu = this.data.find(m => m.module_id === menuId);
      if (!menu || !menu.permissions) return;
      const perm = menu.permissions.find(p => p.id === permId);
      if (!perm) return;
      perm.selected = !perm.selected;
      if (perm.selected) {
        if (!this.selectedPermissions.includes(permId)) {
          this.selectedPermissions.push(permId);
        }
      } else {
        const idx = this.selectedPermissions.indexOf(permId);
        if (idx !== -1) this.selectedPermissions.splice(idx, 1);
      }
    },
    getMenu() {
      this.$vs.loading();
      this.$http.get("/api/account/v1/setting/menu-v1", { params: { source: "WMS" } }).then(resp => {
        if (resp.status === "OK") {
          // Flatten menu and submenus, include permissions
          const x = resp.data.records;
          const result = x.reduce((r, a) => {
            r[a.parent_id] = r[a.parent_id] || [];
            r[a.parent_id].push(a);
            return r;
          }, Object.create(null));
          let y = [];
          let z = [];
          let a = [];
          Object.keys(result).forEach(key => {
            if (key == 0) {
              result[key].forEach(element => {
                z.push({
                  module_id: element.id,
                  display_name: element.display_name,
                  permissions: element.permissions || []
                });
              });
            }
            if (key != 0) {
              result[key].forEach(element => {
                y.push({
                  parent_id: element.parent_id,
                  display_name: element.display_name,
                  module_id: element.id,
                  permissions: element.permissions || []
                });
              });
            }
          });
          z.forEach(elementZ => {
            a.push({
              parent_id: 0,
              module_id: elementZ.module_id,
              display_name: elementZ.display_name,
              selected: false,
              permissions: (elementZ.permissions || []).map(p => ({
                ...p,
                selected: false
              }))
            });
            y.forEach(elementY => {
              if (elementY.parent_id == elementZ.module_id) {
                a.push({
                  parent_id: elementY.parent_id,
                  display_name: elementY.display_name,
                  module_id: elementY.module_id,
                  selected: false,
                  permissions: (elementY.permissions || []).map(p => ({
                    ...p,
                    selected: false
                  }))
                });
              }
            });
          });
          this.data = a;
        }
        this.getData();
      });
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get("/api/account/v1/setting/role-menu-v1/" + this.$route.params.id, )
        .then(resp => {
          if (resp.status === "OK") {
            this.$vs.loading.close();
            this.role = resp.data.display_name;
            const modules = resp.data.module;
            this.selected = [];
            this.selectedPermissions = [];
            this.data.forEach(menu => {
              const mod = modules.find(m => m.module_id === menu.module_id);
              if (mod) {
                menu.selected = true;
                if (!this.selected.includes(menu.module_id)) {
                  this.selected.push(menu.module_id);
                }
                // Preselect permissions
                if (mod.permissions && menu.permissions) {
                  mod.permissions.forEach(selPerm => {
                    const perm = menu.permissions.find(p => p.id === selPerm.id);
                    if (perm) {
                      perm.selected = true;
                      if (!this.selectedPermissions.includes(perm.id)) {
                        this.selectedPermissions.push(perm.id);
                      }
                    }
                  });
                }
              }
            });
          }
        });
    },
    handleSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.$route.params.id) {
            this.putData();
          }
        }
      });
    },
    paramData() {
      return {
        menu: this.selected,
        permissions: this.selectedPermissions
      };
    },
    putData() {
      this.$http
        .put("/api/account/v1/setting/role-menu-v1/" + this.$route.params.id, this.paramData())
        .then(resp => {
          this.$vs.loading.close();
          if (resp.code == 200) {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: "Role Menu Updated",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle"
            });
            this.handleClose();
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle"
            });
          }
        })
        .catch(error => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    handleClose() {
      this.$router.push({ name: "role-menu" });
    },
  }
};
</script>
